module.exports = __webpack_public_path__ + "img/Baumarktexkursion.b3a45663.svg";